import { buildReducer } from '../../../../shared';
import { initGroupsHubWithPrefetchDataAction } from '../../../actions/data/groups/unifiedGroupActions';

export default buildReducer<boolean>()
    .handleDataAction(initGroupsHubWithPrefetchDataAction, (state, action) => {
        return true;
    })
    .done(false);
export type { Action } from '../../../../shared';
